import { Directive, ElementRef, Host, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { AumicoStyleOptions } from '@modeso/types__aumico-lib-core-be';

@Directive({
    selector: '[hamFormat]',
})
export class HamFormatDirective implements OnInit, OnChanges {
    /**
     * The styles/tokens you want to apply
     * e.g. hamFormat="bold", or hamFormat="['bold','italic']"
     */
    @Input() hamFormat: AumicoStyleOptions | AumicoStyleOptions[] | undefined;

    /**
     * Flag to indicate if this is the first or last column cell
     */
    @Input() isFirstOrLast: boolean = false;

    constructor(
        @Optional()
        @Host()
        private elRef: ElementRef<HTMLElement>,
    ) {}

    ngOnInit() {
        this.applyStyles();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['hamFormat'] && changes['hamFormat'].currentValue != null) {
            this.applyStyles();
        }
        if (changes['isFirstOrLast'] && this.hamFormat) {
            this.applyStyles();
        }
    }

    /**
     * Applies the requested styles to the input element.
     */
    private applyStyles(): void {
        // If we have a host component that implements HasNativeInput,
        // use the real <input>. Otherwise fallback to the host element itself.
        const element = this.elRef.nativeElement;

        if (!element) return;

        // Reset styles before applying new ones
        element.style.textAlign = 'left';
        element.style.fontStyle = 'normal';
        element.style.textDecoration = 'none';

        // Convert AumicoStyleOptions to an array to handle multiple styles
        const styles = Array.isArray(this.hamFormat) ? this.hamFormat : [this.hamFormat];

        styles.forEach((style) => {
            switch (style) {
                case AumicoStyleOptions.BOLD:
                    element.style.fontWeight = 'bold';
                    break;

                case AumicoStyleOptions.ITALIC:
                    element.style.fontStyle = 'italic';
                    break;

                case AumicoStyleOptions.UNDERLINED:
                    element.style.textDecoration = 'underline';
                    break;

                case AumicoStyleOptions.LEFT_ALIGNED:
                    element.style.textAlign = 'left';
                    if (!this.isFirstOrLast) {
                        element.style.paddingLeft = '5pt';
                    } else {
                        element.style.paddingLeft = '0pt';
                    }
                    break;

                case AumicoStyleOptions.RIGHT_ALIGNED:
                    element.style.textAlign = 'right';
                    if (!this.isFirstOrLast) {
                        element.style.paddingRight = '5pt';
                    } else {
                        element.style.paddingRight = '0pt';
                    }
                    break;

                case AumicoStyleOptions.CENTER_ALIGNED:
                    element.style.textAlign = 'center';
                    break;
            }
        });
    }
}
